export default __webpack_public_path__ + "static/media/hand_dark.556ba967.png";